export default "__VITE_ASSET__DMGFIYiN__"